import { ApplicationConfig, ENV } from "../types";

export const config: ApplicationConfig = {
  ENV: ENV.TEST,
  AUTH0: {
    AUDIENCE: "https://api.test.unlikely.ai",
    CLIENT_ID: "AxUUHDgMxK4FthY0kRZC1gIPMXNJMQ3t",
    DOMAIN: "unlikelyai-test.uk.auth0.com",
  },
  DEMO_ORGANISATION_ID: "org_buwiSKJLAwFMl4U7",
  LLOYDS_ORGANISATION_ID: "org_EA0rq2f47NDBbbnK",
  NATWEST_ORGANISATION_ID: "org_r1dyimi9nVirg60K",
};
